// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1b6ia","buttons":"Footer_buttons__2uNxv"};